import FlashMessages    from 'mixins/flash'
import {displaySuccessFlash, displayErrorFlash} from 'servos/ajaxFlash'
import MainFooter from 'containers/common/components/MainFooter'
import React          from 'react'
import ReactDOM       from 'react-dom'

class Controller {
  call() {
    document.controller = this

    // EXAMPLE
    // this.flash = { options: { message: 'You have updated your account settings, well done mate.', url: 'http://www.google.com', icon: 'fa fa-check' }, settings: { type: 'info', placement: { from: 'top', align: 'center' } } }

    FlashMessages.call(this, this.flash)

    // Display flash messages from AJAX responses
    displaySuccessFlash.call(this)

    // Display flash messages from AJAX responses
    displayErrorFlash.call(this)
    addToggleNavbarListener()
    addNavDropdownListener()
    addNavbarScrollListener()
    const domMainCalcFooter = document.getElementById('calculators-footer')

    if (domMainCalcFooter) {
      ReactDOM.render(<MainFooter />, domMainCalcFooter)
    }
  }
}

function addToggleNavbarListener() {
  const navbarToggle = document.getElementById("main-navbar-toggle")
  if(navbarToggle) {
    const navbarFlex = document.getElementById("yard-navbar-flex")
    navbarToggle.addEventListener('click', function() {
      const expandedDropdowns = document.querySelectorAll(".dropdown-expanded");
      expandedDropdowns.forEach(dropdown => {
        dropdown.classList.remove('dropdown-expanded');
        dropdown.classList.add('dropdown-collapsed');
      });

      navbarFlex.classList.contains('expanded') ?
        navbarFlex.classList.remove('expanded') :
        navbarFlex.classList.add('expanded')
      navbarToggle.classList.contains('active') ?
        navbarToggle.classList.remove('active') :
        navbarToggle.classList.add('active')
    })
  }
}

function addNavDropdownListener() {
  const dropdownToggles = document.querySelectorAll(".yard-navbar__main-text");

  if (dropdownToggles.length > 0) {
    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        handleDropdownToggle(toggle);
      });
    });
  }
}

function handleDropdownToggle(toggle) {
  const isExpanded = toggle.classList.contains('dropdown-expanded');

  // Collapse all expanded dropdowns
  const expandedDropdowns = document.querySelectorAll(".dropdown-expanded");
  expandedDropdowns.forEach(dropdown => {
    dropdown.classList.remove('dropdown-expanded');
    dropdown.classList.add('dropdown-collapsed');
  });

  // Toggle the clicked dropdown
  if (!isExpanded) {
    toggle.classList.remove('dropdown-collapsed');
    toggle.classList.add('dropdown-expanded');
  }
}

function addNavbarScrollListener() {
  const navbarWrapper = document.getElementById("navbar-wrapper")
  if (navbarWrapper) {
    window.addEventListener("scroll", function() {
      document.documentElement.scrollTop > 0 ? navbarWrapper.classList.add('sticky') : navbarWrapper.classList.remove('sticky')
    })
  }
}


export default Controller
